<template>
    <div class="pageContent wallet">
      <pageTitle title='我的储值卡' />
        <div class='open'>
        <img src='../../../static/wallet/noValue.png'/>
        <p><label>您还没有储值卡哦</label></p>
        <router-link to="/wallet/openValueCard">开通储值卡</router-link>
        </div>
    </div>
</template>
<style lang="less" scoped>
    .wallet{
        background-color:#f5f5f5;
        .open{
            text-align:center;
            a{
                font-size:0.3rem;
                color:#27ba69;
                border:2px solid #27ba69;
                display:inline-block;
                width:2.8rem;
                height:0.72rem;
                line-height:0.67rem;
                padding:0;
                margin-top:1rem;
                border-radius:2px;
            }
            p{
                margin:0.4rem 0 0 0;
            }
            label{
                color:#999999;
                font-size:0.28rem;
                margin:0rem;
            }
            img{
                margin-top:2.3rem;
                max-width:2rem;
            }
        }
    }
</style>

<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

export default {
  data() {
    return {}
  },
  methods: {},
  computed: {
    ...mapGetters({
      userInfo: "g_UserInfo"
    })
  },

  activated() {
    var that = this
    if (this.userInfo.Card_no == "" || typeof this.userInfo.Card_no == "undefined") 
    {
        this.showToast('您尚未登录，请先登录！')
        setTimeout(function() {
          that.$router.push({ path: "/user/Login" })
        }, 2000);
    }
    else if(this.userInfo.HasOpenStoreCard){
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// noValueCard.vue?c3699608